import React, { useEffect } from "react";
import { Stack } from "@mui/material";
import Paper from "@mui/material/Paper";
import _ from "lodash";
import {
  context_styles
} from "../mi_styles";
import "../mi.css";
import { LinearProgressDark } from "../miComponents/styled_linear_progress";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { useSpring, animated } from '@react-spring/web';
import { alpha, styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';
import { miActions } from "../../store/store";
import { useDispatch, useSelector } from "react-redux";
import ColorPicker from "../miComponents/color_picker";
import { makeStyles } from '@mui/styles';
import { Projects } from "../miComponents/projects";
import { StyledAutocompleteDark } from "../miComponents/styled_autocomplete";
import TextField from "@mui/material/TextField";
import { Chip } from '@mui/material';

const useAutoCompleteStyles = makeStyles({
  option: {
    fontSize: '0.875rem',
  },
});

const useChipStyles = makeStyles({
  customChip: {
    backgroundColor: 'rgba(0, 255, 255, 0.15)',
    color: "rgba(245, 245, 245, 0.75)"
  },
});

const DarkSwitch = styled(Switch)(({ theme }) => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: "rgba(0, 255, 255, 0.65)",
    '&:hover': {
      backgroundColor: alpha("rgba(0, 255, 255, 0.65)", theme.palette.action.hoverOpacity),
    },
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: "rgba(0, 255, 255, 0.65)",
  },
}));

export default function Preferences(props) {
  const autocomplete_classes = useAutoCompleteStyles();
  const classes = useChipStyles();
  const {
    color,
    col_100,
    mode,
    modes
  } = useSelector(state => state.miStore);
  const {
    page,
    prevPage
  } = useSelector(state => state.miStore);
  const dispatch = useDispatch();

  const StyledChip = styled(Chip)(({ theme }) => ({
    backgroundColor: col_100,
    color: "rgba(245, 245, 245, 0.75)"
  }));


  const [springs, api] = useSpring(() => ({
    from: {
      y: 0
    },
    config: {
      mass: 7
    }
  }))

  useEffect(() => {
    api.start({
      from: {
        y: -15 + "%"
      },
      to: {
        y: 0 + "%"
      }
    })
  }, [])

  const handlePageChange = () => {
    dispatch(miActions.changePage(prevPage));
  }

  const changeColor = (e) => {
    dispatch(miActions.changeAccentColor(e.color))
  }

  const handleFilterOptionChange = (e, type) => {
    if (e) {
      dispatch(miActions.setMode(e))
    }
  }

  const renderSelectedOptions = (selectedOptions, { inputValue }) => {
    /**
     * The delete option in the chip is not configured (yet...)
     */
    let displayedOptions = selectedOptions.slice(0, 0);

    if (selectedOptions.length > 0) {
      const remainingCount = selectedOptions.length;
      const remainingOptions = `+${remainingCount}`;
      displayedOptions = displayedOptions.concat(remainingOptions);
    }

    return (
      <div>
        {displayedOptions.map((option, index) => (
          <StyledChip
            size="small"
            key={index}
            label={option}
            onDelete={() => handleFilterOptionChange(option, "")}
          />
        ))}
      </div>
    );
  };

  return (
    <animated.div style={{ ...springs }}>
      <Paper elevation={5} sx={context_styles}>
        {props.load &&
          <LinearProgressDark className="context-loader-dark" />
        }
        <Stack 
          spacing={1.5} 
          className="container"
        >
          <Stack direction="row" className="page-header-dark">
            <ChevronLeftIcon className="left-dark" onClick={handlePageChange} />
            <span>Preferences</span>
            <span className="right-dark"></span>
          </Stack>

          <Stack
            className="preferences-content"
            spacing={2}
          >
            <div
              className="accent-switcher"
            >
              <span>Accent Color</span>
              <ColorPicker 
                type="accent-color"
                color={color}
                changeColor={changeColor}
              />
            </div>

            <StyledAutocompleteDark
              sx={{ width: "15rem" }}
              classes={{
                option: autocomplete_classes.option,
              }}
              id="size-small-outlined-multi"
              size="small"
              noOptionsText="data not available"
              value={mode}
              componentsProps={{ popper: { style: { width: 'fit-content' } } }}
              options={modes}
              getOptionLabel={(option) => option}
              renderInput={(params) => (
                <TextField {...params} variant="outlined" placeholder={`Search mode  ( ${modes.length} )`} />
              )}
              renderTags={renderSelectedOptions}
              onChange={(event, value) => handleFilterOptionChange(value, "audit")}
            />
          </Stack>
        </Stack>

        {/* project info/switcher */}
        <Projects />
      </Paper>
    </animated.div>
  )
}